var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtaOtherMeetingActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.595703,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.0957,
    cy: 6,
    r: 4,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtaOtherMeetingActive);
export default __webpack_public_path__ + "static/media/pta_other_meeting_active.b24b75be8613b14ce3a5a508ead1d00e.svg";
export { ForwardRef as ReactComponent };